import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import HomePage from "./pages/HomePage/HomePage";
import Header from "./pages/Header/Header";
import Footer from "./pages/Footer/Footer";
import colors from "./Assest/Theme/Color";
import ContactUsPage from "./pages/ContactUs/ContactUsPage";
import AboutUsPage from "./pages/AboutUs/AboutUsPage";
import Curriculum from "./pages/Curriculum/Curriculum";
import Calander from "./pages/Program/Calander/Calander";
import Event from "./pages/Program/Event/Event";
import Login from "./pages/Login/Login";
import Register from "./pages/Register/Register";
import Verify from "./pages/Register/Verify";
import Routings from "./Routings";
import Volunteerspart from "./pages/Volunteers/Volunteerspart";
import DashboardLayout from "./dashboard/DashboardLayout";
import HomeConfig from "./dashboard/Configuration/HomeConfig/HomeConfig";
import AboutUsConfig from "./dashboard/Configuration/AboutUsConfig/AboutUsConfig";
import CurriculumConfig from "./dashboard/Configuration/Curriculum/CurriculumConfig";
import Awardpart from "./pages/Award/Awardpart";
import Biliteracy from "./pages/Award/Biliteracy";
import Accredited from "./pages/Award/Accredited";
import Volunteersadd from "./pages/Volunteers/Volunteersadd";
import Success from "./pages/Volunteers/Success";
import PickupDrop from "./StudentDashBoard/PickupDrop/PickupDrop";
import Withdraw from "./StudentDashBoard/Withdraw/Withdraw";
import Complaint from "./StudentDashBoard/Complaint/Complaint";
import LeaveRequest from "./StudentDashBoard/LeaveRequest/LeaveRequest";
import ClassRoom from "./StudentDashBoard/classRoom/ClassRoom";
import StudentDashboard from "./StudentDashBoard/StudentDashBoard/StudentDashboard";
import AcademicDocuments from "./StudentDashBoard/AcademicDocuments/AcademicDocuments";
import Textbooks from "./StudentDashBoard/Textbooks/Textbooks";
import ClassroomResources from "./StudentDashBoard/ClassroomResources/ClassroomResources";
import ProgressReport from "./StudentDashBoard/ProgressReport/ProgressReport";
import StudentProjectGuidelines from "./StudentDashBoard/ProjectGuidelines/ProjectGuidelines";
import SealOfBiliteracy from "./StudentDashBoard/SealOfBiliteracy/SealOfBiliteracy";
import StudentRegistration from "./pages/StudentRegistration/StudentRegistration";
import RegistrationSuccess from "./pages/StudentRegistration/RegistrationSuccess";
import AdminRegistrations from "./dashboard/AdminRegistrations/AdminRegistrations";
import AdminAdmissions from "./dashboard/AdminAdmissions/AdminAdmissions";
import ClassroomManagement from "./dashboard/AdminClassroom/ClassroomManagement";
import AdminDashboard from "./dashboard/AdminDashboard/AdminDashboard";
import AdminMaster from "./dashboard/AdminMaster/AdminMaster";
import AdminVolunteers from "./dashboard/AdminVolunteers/AdminVolunteers";
import AdminAttendance from "./dashboard/AdminAttendance/AdminAttendance";
import AdminPayment from "./dashboard/AdminPayment/AdminPayment";
import AdminComplaints from "./dashboard/AdminComplaints/AdminComplaints";
import AdminInventory from "./dashboard/AdminInventory/AdminInventory";
import AdminRoleConfig from "./dashboard/AdminRoleConfig/AdminRoleConfig";
import AdminRepository from "./dashboard/AdminRepository/AdminRepository";
import AdminProjectGuidelines from "./dashboard/AdminProjectGuidelines/AdminProjectGuidelines";
// Teacher imports
import TeacherDashboard from "./TeacherDashBoard/TeacherDashboard";
import TeacherStudentList from "./TeacherDashBoard/StudentList/StudentList";
import TeacherAttendance from "./TeacherDashBoard/Attendance/Attendance";
import TeacherProgressReport from "./TeacherDashBoard/ProgressReport/ProgressReport";
import TeacherBiliteracy from "./TeacherDashBoard/BiliteracyEvaluation/BiliteracyEvaluation";
import TeacherQuestionPaper from "./TeacherDashBoard/QuestionPaper/QuestionPaper";
import TeacherClassroom from "./TeacherDashBoard/GoogleClassroom/GoogleClassroom";
import TeacherPickupDrop from "./TeacherDashBoard/PickupDrop/PickupDrop";
import TeacherDocuments from "./TeacherDashBoard/DocumentPlaceholder/DocumentPlaceholder";
import TeacherComplaints from "./TeacherDashBoard/ComplaintManagement/ComplaintManagement";
import TeacherLeave from "./TeacherDashBoard/LeaveManagement/LeaveManagement";
import TeacherReImbursement from "./TeacherDashBoard/ReImbursement/ReImbursement";
import TeacherProjectGuidelines from "./TeacherDashBoard/ProjectGuidelines/ProjectGuidelines";
import TeacherSubmissions from "./TeacherDashBoard/Submissions/SubmissionReview";
// New admin pages
import AdminWithdrawal from "./dashboard/AdminWithdrawal/AdminWithdrawal";
import AdminFormAccess from "./dashboard/AdminFormAccess/AdminFormAccess";
import AdminPasswordReset from "./dashboard/AdminPasswordReset/AdminPasswordReset";
import AdminWebsiteConfig from "./dashboard/AdminWebsiteConfig/AdminWebsiteConfig";
import AdminSocialMedia from "./dashboard/AdminSocialMedia/AdminSocialMedia";
import VPLeavePortal from "./dashboard/VPLeavePortal/VPLeavePortal";
// New teacher pages
import TeacherProfile from "./TeacherDashBoard/TeacherProfile/TeacherProfile";
// New admin config pages
import AdminBiliteracy from "./dashboard/AdminBiliteracy/AdminBiliteracy.jsx";
import AdminCalendarConfig from "./dashboard/AdminCalendarConfig/AdminCalendarConfig";
import AdminEventConfig from "./dashboard/AdminEventConfig/AdminEventConfig";
import AdminContactUsConfig from "./dashboard/AdminContactUsConfig/AdminContactUsConfig";
import AdminSealBiliteracyConfig from "./dashboard/AdminSealBiliteracyConfig/AdminSealBiliteracyConfig";
import StudentProfile from "./StudentDashBoard/StudentProfile/StudentProfile";
import NotFound from "./pages/NotFound/NotFound";
// Parent Portal imports
import ParentDashboard from "./ParentDashBoard/ParentDashboard/ParentDashboard";
import ParentStudentProfile from "./ParentDashBoard/StudentProfile/ParentStudentProfile";
import ParentProgressReport from "./ParentDashBoard/ProgressReport/ParentProgressReport";
import ParentAttendance from "./ParentDashBoard/Attendance/ParentAttendance";
import ParentComplaint from "./ParentDashBoard/Complaint/ParentComplaint";
import ParentWithdrawal from "./ParentDashBoard/Withdrawal/ParentWithdrawal";
// Staff Portal imports
import StaffDashboard from "./StaffDashBoard/StaffDashboard/StaffDashboard";
import StaffCheckInOut from "./StaffDashBoard/CheckInOut/CheckInOut";
import StaffLeaveCalendar from "./StaffDashBoard/LeaveCalendar/LeaveCalendar";
import StaffLeaveManagement from "./StaffDashBoard/LeaveManagement/StaffLeaveManagement";
import StaffMandateLeave from "./StaffDashBoard/MandateLeave/MandateLeaveForm";
import StaffProfile from "./StaffDashBoard/StaffProfile/StaffProfile";
// Principal Portal imports
import PrincipalDashboard from "./PrincipalDashBoard/PrincipalDashboard/PrincipalDashboard";
import PrincipalRegistrations from "./PrincipalDashBoard/Registrations/PrincipalRegistrations";
import PrincipalWithdrawal from "./PrincipalDashBoard/Withdrawal/PrincipalWithdrawal";
import PrincipalLeaveApprovals from "./PrincipalDashBoard/LeaveApprovals/PrincipalLeaveApprovals";
// Flipbook
import Flipbook from "./pages/Flipbook/Flipbook";
import AdminFlipbook from "./dashboard/AdminFlipbook/AdminFlipbook";
// Gap fixes #31, #35
import SessionTimeout from "./DynamicComponent/SessionTimeout";
import StaffInventory from "./StaffDashBoard/Inventory/StaffInventory";
// New admin pages (gaps #5-#8, #10)
import AdminStaffAttendance from "./dashboard/AdminStaffAttendance/AdminStaffAttendance";
import AdminQuestionPaper from "./dashboard/AdminQuestionPaper/AdminQuestionPaper";
import AdminTextbooks from "./dashboard/AdminTextbooks/AdminTextbooks";
import AdminGoogleClassroom from "./dashboard/AdminGoogleClassroom/AdminGoogleClassroom";
import Handbooks from "./pages/Handbooks/Handbooks";

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

function AppContent() {
  const location = useLocation();

  const isLoginPage =
    location.pathname === Routings.LOGIN ||
    location.pathname === Routings.REGISTER ||
    location.pathname === Routings.VERIFY;

  const isDashboardPage = location.pathname.startsWith(Routings.DASHBOARD);

  const value = sessionStorage.getItem("role");

  console.log("value", value)

  return (
    <div className="App" style={{ backgroundColor: colors.bgColor }}>
      {!isDashboardPage && <Header style={{marginBottom:'4%'}}/>}
      <Routes>
        <Route path={Routings.HOME} element={<HomePage />} />
        <Route path={Routings.CURRICULUM} element={<Curriculum />} />
        <Route path={Routings.PROGRAM_CALENDAR} element={<Calander />} />
        <Route path={Routings.PROGRAM_EVENT} element={<Event />} />
        <Route path={Routings.ABOUT_US} element={<AboutUsPage />} />
        <Route path={Routings.CONTACT_US} element={<ContactUsPage />} />
        <Route path={Routings.LOGIN} element={<Login />} />
        <Route path={Routings.REGISTER} element={<Register />} />
        <Route path={Routings.VERIFY} element={<Verify />} />
        <Route path={Routings.VOLUNTEERS} element={<Volunteerspart />} />
        <Route path={Routings.STUDENT_REGISTRATION} element={<StudentRegistration />} />
        <Route path={Routings.REGISTRATION_SUCCESS} element={<RegistrationSuccess />} />
        <Route path={Routings.DASHBOARD} element={<><SessionTimeout /><DashboardLayout /></>}>
          {value === "/student" ? (
            <Route index element={<StudentDashboard />} />
          ) : value === "/teacher" ? (
            <Route index element={<TeacherDashboard />} />
          ) : value === "/parent" ? (
            <Route index element={<ParentDashboard />} />
          ) : value === "/staff" ? (
            <Route index element={<StaffDashboard />} />
          ) : value === "/principal" ? (
            <Route index element={<PrincipalDashboard />} />
          ) : (
            <Route index element={<AdminDashboard />} />
          )}
          <Route path={Routings.HOMECONFIG} element={<HomeConfig />} />
          <Route path={Routings.ABOUTUSCONFIG} element={<AboutUsConfig />} />
          <Route
            path={Routings.CURRICULUMCONFIG}
            element={<CurriculumConfig />}
          />
          <Route path={Routings.ADMIN_REGISTRATIONS} element={<AdminRegistrations />} />
          <Route path={Routings.ADMIN_ADMISSIONS} element={<AdminAdmissions />} />
          <Route path={Routings.ADMIN_CLASSROOM_MGMT} element={<ClassroomManagement />} />
          <Route path={Routings.ADMIN_MASTER} element={<AdminMaster />} />
          <Route path={Routings.ADMIN_VOLUNTEERS} element={<AdminVolunteers />} />
          <Route path={Routings.ADMIN_ATTENDANCE} element={<AdminAttendance />} />
          <Route path={Routings.ADMIN_PAYMENT} element={<AdminPayment />} />
          <Route path={Routings.ADMIN_COMPLAINTS} element={<AdminComplaints />} />
          <Route path={Routings.ADMIN_INVENTORY} element={<AdminInventory />} />
          <Route path={Routings.ADMIN_ROLE_CONFIG} element={<AdminRoleConfig />} />
          <Route path={Routings.ADMIN_REPOSITORY} element={<AdminRepository />} />
          <Route path={Routings.ADMIN_PROJECT_GUIDELINES} element={<AdminProjectGuidelines />} />
          <Route path={Routings.ADMIN_WITHDRAWAL} element={<AdminWithdrawal />} />
          <Route path={Routings.ADMIN_FORM_ACCESS} element={<AdminFormAccess />} />
          <Route path={Routings.ADMIN_PASSWORD_RESET} element={<AdminPasswordReset />} />
          <Route path={Routings.ADMIN_WEBSITE_CONFIG} element={<AdminWebsiteConfig />} />
          <Route path={Routings.ADMIN_SOCIAL_MEDIA} element={<AdminSocialMedia />} />
          <Route path={Routings.ADMIN_VP_LEAVE} element={<VPLeavePortal />} />
          <Route path={Routings.TEACHER_PROFILE} element={<TeacherProfile />} />
          <Route path={Routings.ADMIN_BILITERACY} element={<AdminBiliteracy />} />
          <Route path={Routings.ADMIN_CALENDAR_CONFIG} element={<AdminCalendarConfig />} />
          <Route path={Routings.ADMIN_EVENT_CONFIG} element={<AdminEventConfig />} />
          <Route path={Routings.ADMIN_CONTACT_CONFIG} element={<AdminContactUsConfig />} />
          <Route path={Routings.ADMIN_SEAL_CONFIG} element={<AdminSealBiliteracyConfig />} />
          <Route path={Routings.STUDENT_PROFILE} element={<StudentProfile />} />
          {/* Student Routes */}
          <Route path={Routings.LEAVEREQUEST} element={<LeaveRequest />} />
          <Route path={Routings.CLASSROOM} element={<ClassRoom />} />
          <Route path={Routings.STUDENT_ACADEMIC_DOCS} element={<AcademicDocuments />} />
          <Route path={Routings.STUDENT_TEXTBOOKS} element={<Textbooks />} />
          <Route path={Routings.COMPLAINT} element={<Complaint />} />
          <Route path={Routings.STUDENT_CLASSROOM_RESOURCES} element={<ClassroomResources />} />
          <Route path={Routings.WITHDRAW} element={<Withdraw />} />
          <Route path={Routings.STUDENT_PROGRESS_REPORT} element={<ProgressReport />} />
          <Route path={Routings.STUDENT_PROJECT_GUIDELINES} element={<StudentProjectGuidelines />} />
          <Route path={Routings.PICUPANDDROP} element={<PickupDrop />} />
          <Route path={Routings.STUDENT_SEAL_BILITERACY} element={<SealOfBiliteracy />} />
          {/* Parent Routes */}
          <Route path={Routings.PARENT_STUDENT_PROFILE} element={<ParentStudentProfile />} />
          <Route path={Routings.PARENT_PROGRESS_REPORT} element={<ParentProgressReport />} />
          <Route path={Routings.PARENT_ATTENDANCE} element={<ParentAttendance />} />
          <Route path={Routings.PARENT_COMPLAINT} element={<ParentComplaint />} />
          <Route path={Routings.PARENT_WITHDRAWAL} element={<ParentWithdrawal />} />
          {/* Staff Routes */}
          <Route path={Routings.STAFF_INVENTORY} element={<StaffInventory />} />
          <Route path={Routings.STAFF_CHECKINOUT} element={<StaffCheckInOut />} />
          <Route path={Routings.STAFF_LEAVE_CALENDAR} element={<StaffLeaveCalendar />} />
          <Route path={Routings.STAFF_LEAVE} element={<StaffLeaveManagement />} />
          <Route path={Routings.STAFF_MANDATE_LEAVE} element={<StaffMandateLeave />} />
          <Route path={Routings.STAFF_PROFILE} element={<StaffProfile />} />
          {/* Principal Routes */}
          <Route path={Routings.PRINCIPAL_REGISTRATIONS} element={<PrincipalRegistrations />} />
          <Route path={Routings.PRINCIPAL_WITHDRAWAL} element={<PrincipalWithdrawal />} />
          <Route path={Routings.PRINCIPAL_LEAVE} element={<PrincipalLeaveApprovals />} />
          {/* Admin Flipbook */}
          <Route path={Routings.ADMIN_FLIPBOOK} element={<AdminFlipbook />} />
          {/* Admin gap fixes #5-#8 */}
          <Route path={Routings.ADMIN_STAFF_ATTENDANCE} element={<AdminStaffAttendance />} />
          <Route path={Routings.ADMIN_QUESTION_PAPER} element={<AdminQuestionPaper />} />
          <Route path={Routings.ADMIN_TEXTBOOKS} element={<AdminTextbooks />} />
          <Route path={Routings.ADMIN_GOOGLE_CLASSROOM} element={<AdminGoogleClassroom />} />
          {/* Teacher Routes */}
          <Route path={Routings.TEACHER_STUDENT_LIST} element={<TeacherStudentList />} />
          <Route path={Routings.TEACHER_ATTENDANCE} element={<TeacherAttendance />} />
          <Route path={Routings.TEACHER_PROGRESS_REPORT} element={<TeacherProgressReport />} />
          <Route path={Routings.TEACHER_BILITERACY} element={<TeacherBiliteracy />} />
          <Route path={Routings.TEACHER_QUESTION_PAPER} element={<TeacherQuestionPaper />} />
          <Route path={Routings.TEACHER_CLASSROOM} element={<TeacherClassroom />} />
          <Route path={Routings.TEACHER_PICKUP_DROP} element={<TeacherPickupDrop />} />
          <Route path={Routings.TEACHER_DOCUMENTS} element={<TeacherDocuments />} />
          <Route path={Routings.TEACHER_COMPLAINTS} element={<TeacherComplaints />} />
          <Route path={Routings.TEACHER_LEAVE} element={<TeacherLeave />} />
          <Route path={Routings.TEACHER_REIMBURSEMENT} element={<TeacherReImbursement />} />
          <Route path={Routings.TEACHER_PROJECT_GUIDELINES} element={<TeacherProjectGuidelines />} />
          <Route path={Routings.TEACHER_SUBMISSIONS} element={<TeacherSubmissions />} />
        </Route>
        <Route path={Routings.ACCREDITED} element={<Accredited />} />
        <Route path={Routings.AWARDPART} element={<Awardpart />} />
        <Route path={Routings.BILITERACY} element={<Biliteracy />} />
        <Route path={Routings.VOLUNTEERSADD} element={<Volunteersadd />} />
        <Route path={Routings.SUCCESS} element={<Success />} />
        <Route path={Routings.FLIPBOOK} element={<Flipbook />} />
        <Route path={Routings.HANDBOOKS} element={<Handbooks />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!isLoginPage && !isDashboardPage && <Footer />}
    </div>
  );
}

export default App;
